// src/components/models/ModelTable.js
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { useCarContext } from '../components/Context/CarContext';
import { DeleteModels } from '../services/api';
import ConfirmDialog from './ConfirmDialog';
import EditDialogModel from './EditDialog/EditDialogModel';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
const ModelTable = ({  deleteModel,  filterBrandId }) => {
  // Helper function to get brand name by brandId
    const { models, brands, editModel, UpdateModel, DeleteModel, editEngine, editOpen, setEditOpen, editType, UpdateEngineClass, currentEditData } = useCarContext();
  const [open, setOpen] = useState(false);
  const [selectedModelId, setSelectedModelId] = useState(null); 
  const handleDeleteClick = (id) => {
    setSelectedModelId(id); // Set the brand ID to delete
    setOpen(true); // Open the confirmation dialog
  };

  const handleClose = () => {
    setOpen(false); // Close the confirmation dialog
    setSelectedModelId(null); // Clear the selected brand ID
  };

  const handleConfirm = () => {
    if (selectedModelId) {
      DeleteModel(selectedModelId); // Delete the selected brand
    }
    setOpen(false); // Close the confirmation dialog
  };
  const getBrandName = (brandId) => {
    const brand = brands.find((b) => b.id === brandId);
    return brand ? brand.name : 'Unknown Brand';
  };
    const handleSaveEditModel = (updatedData) => {

        /* setUpdated(updatedData)*/
        UpdateModel(updatedData)
    };

    const columns = [
      { field: 'link', 
        headerName: 'Link', 
        width: 50, 
        renderCell: (params) => ( 
        <i className="bi bi-info-circle"></i> 
        ), 
      },
      { 
        field: 'name', 
        headerName: 'Model Name',
         width: 150, 
      }, 
      { field: 'brand', 
        headerName: 'Brand Name', 
        width: 150, 
        renderCell: (params) => { 
          const brand = brands.find((b) => b.id === params.row.brandId); return brand ? brand.name : 'Unknown Brand'; 
        }, 
      }, 
      { 
        field: 'action', 
        headerName: 'Action', 
        width: 150, 
        renderCell: (params) => ( 
        <div> 
          <IconButton color="primary" onClick={() => editModel(params.row)} > 
            <Edit /> 
          </IconButton> 
          <IconButton color="secondary" onClick={() => handleDeleteClick(params.row.id)} > 
            <Delete /> 
          </IconButton> 
        </div> ), 
      },
     ]; 
     const CustomToolbar = () => ( 
      <GridToolbarContainer> 
        <GridToolbar /> 
      </GridToolbarContainer> 
      );
 function EditToolbar(props) {
     const { setRows, setRowModesModel } = props;
 }
   return(
    <section className="section">
    <div className="row">
      <div className="col-lg-12">
            <div className="card">
                <div className="card-body">
                  <h5 className="card-title"></h5>
                    {/* Tabs */}
                    <Box sx={{ width: '100%' }}>
                        <AppBar position="static" color="default">
                            {/* AppBar content can go here */}
                        </AppBar>
                    </Box>
                    <div style={{ height: '100%', width: '100%' }}>
                        <DataGrid
                         rows={models}
                         columns={columns}
                         slots={{ toolbar: CustomToolbar }}
                         components={{ Toolbar: GridToolbar }}
                      />
                        <ConfirmDialog
                         open={open}
                         onClose={handleClose}
                         onConfirm={handleConfirm}
                         title="Confirm Deletion"
                         content="Are you sure you want to delete this brand?"
                      />
                  {/* EditDialogBrand for Editing */}
                      <EditDialogModel
                        open={editOpen}
                        handleClose={() => setEditOpen(false)}
                        type={editType}
                        currentData={currentEditData}
                        handleSave={handleSaveEditModel}
                      />
                    </div>
                </div>
            </div>
        </div></div>
</section>
);


  // Apply filter to models
  // const filteredModels = filterBrandId
  
  //   ? models.filter((model) => model.brandId === filterBrandId)
  //   : models;
  //    
 // return (
    // <TableContainer component={Paper}>
    //   <Table aria-label="models table">
    //     <TableHead>
    //       <TableRow>
    //         <TableCell><strong>Model Name</strong></TableCell>
    //         <TableCell><strong>Brand Name</strong></TableCell>
    //         <TableCell align="right"><strong>Actions</strong></TableCell>
    //       </TableRow>
    //     </TableHead>
    //     <TableBody>
    //       {models.length === 0 && (
    //         <TableRow>
    //           <TableCell colSpan={3} align="center">
    //             <Typography variant="body1">No models available.</Typography>
    //           </TableCell>
    //         </TableRow>
    //       )}
    //       {models.map((model) => (
    //         <TableRow key={model.id}>
    //           <TableCell>{model.name}</TableCell>
    //           <TableCell>{getBrandName(model.brandId)}</TableCell>
    //           <TableCell align="right">
    //             <IconButton
    //               color="primary"
    //               onClick={() => editModel(model)}
                  
    //             >
    //               <Edit />
    //             </IconButton>
    //             <IconButton
    //               color="secondary"
    //               onClick={() => handleDeleteClick(model.id)}
    //             >
    //               <Delete />
    //             </IconButton>
    //           </TableCell>
    //         </TableRow>
    //       ))}
    //     </TableBody>
    //   </Table>
    //   <ConfirmDialog
    //   open={open}
    //   onClose={handleClose}
    //   onConfirm={handleConfirm}
    //   title="Confirm Deletion"
    //   content="Are you sure you want to delete this Model?"
    //       />
    //       <EditDialogModel
    //           open={editOpen}
    //           handleClose={() => setEditOpen(false)}
    //           type={editType}
    //           currentData={currentEditData}

    //           handleSave={handleSaveEditModel}
    //       />
    // </TableContainer>
 // );
};

export default ModelTable;
